import { render, staticRenderFns } from "./LoadingButton.vue?vue&type=template&id=656b7b24&scoped=true"
import script from "./LoadingButton.vue?vue&type=script&lang=ts"
export * from "./LoadingButton.vue?vue&type=script&lang=ts"
import style0 from "./LoadingButton.vue?vue&type=style&index=0&id=656b7b24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656b7b24",
  null
  
)

export default component.exports